<template>
    <div :class="{'timeline-email': !hasHTML}" :style="{marginTop: hasHTML ? '16px' : ''}">
        <iframe
            style="width:100%; margin: 0; padding: 0"
            frameborder="0"
            allowtransparency="true"
            sandbox="allow-same-origin"
            :srcdoc="emailSubject"
            scrolling="no"
            @load="resizeBodyIFrame">
        </iframe>
        <div :class="{'timeline-email': hasHTML}" :style="{marginTop: !hasHTML ? '16px' : ''}">
            <iframe
                style="width:100%; margin: 0; padding: 0"
                frameborder="0"
                allowtransparency="true"
                sandbox="allow-same-origin"
                :srcdoc="emailHTML"
                scrolling="no"
                @load="resizeBodyIFrame">
            </iframe>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'email-preview',
        props: {
            subject: {
                type: String,
                required: true,
            },
            text: {
                type: String,
                required: true,
            },
            html: {
                type: String,
                default: '',
            },
        },
        computed: {
            hasHTML() {
                return !!this.html;
            },
            iframecss() {
                return `
                body {
                    font-family: "Roboto", sans-serif;
                    font-size: 14px;
                    font-weight: 400;
                }
                h3 {
                    font-size: 13px;
                    font-weight: bold;
                    text-transform: uppercase;
                    margin: 0;
                }`;
            },
            emailSubject() {
                return `<style>${this.iframecss}</style><h3>${this.subject}</h3>`;
            },
            emailHTML() {
                return this.html || `<style>${this.iframecss}</style><div style="white-space:pre-wrap;">${this.text}</div>`;
            },
        },
        methods: {
            resizeBodyIFrame({target: iFrame}) {
                const contentHeightCorrection = 0;
                const iFrameBody = iFrame.contentWindow.document.body;
                iFrameBody.style.margin = '0px';
                iFrame.style.height = `${iFrameBody.scrollHeight + contentHeightCorrection}px`;
            },
        },
    };
</script>
